import { mockDb } from './mockData';

export const salesService = {
    // Delivery Challan
    getDeliveryChallans: () => mockDb.get('deliveryChallans'),
    createDeliveryChallan: (data) => mockDb.create('deliveryChallans', data),
    updateDeliveryChallan: (id, data) => mockDb.update('deliveryChallans', id, data),
    updateDCStatus: (id, status) => mockDb.update('deliveryChallans', id, { status }),
    toggleGatePass: (id, generated) => mockDb.update('deliveryChallans', id, { gatePass: generated }),
    deleteDeliveryChallan: (id) => mockDb.delete('deliveryChallans', id),

    // Invoice
    getInvoices: () => mockDb.get('invoices'),
    createInvoice: (data) => mockDb.create('invoices', data),
    updateInvoice: (id, data) => mockDb.update('invoices', id, data),
    updateInvoiceStatus: (id, status) => mockDb.update('invoices', id, { status }),
    deleteInvoice: (id) => mockDb.delete('invoices', id),

    // Sales Tax Invoice
    createSalesTaxInvoice: (data) => mockDb.create('invoices', data), // Mocked for now
    deleteSalesTaxInvoice: (id) => mockDb.delete('invoices', id),
};
